(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["juvio-guarantee-dialog"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-juvio-guarantee]');
    const dialog = document.getElementById('juvio-guarantee-dialog');
    if (!dialog) return;
    if (opener && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
    } else if (event.target.closest('[data-juvio-guarantee-close]')) {
      dialog.close();
    } else if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
